import { ReviewsScreen } from '../features/reviews/ReviewsScreen'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

/** Флаг `VITE_FEATURE_REVIEWS` выключен — раздела нет, адрес ведёт в «не найдено». */
export function ReviewsPage() {
  return env.features.reviews ? <ReviewsScreen /> : <NotFoundPage />
}
